export const CATEGORY_TYPE = {
  MAIN: 0,
  SUB_CATEGORY: 1,
} as const;

export const SELECT_TYPE = {
  MULTI: 0,
  UNIQUE: 1,
  REMOVAL: 2,
} as const;